package szlot

import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLElement
import visage.core.Visage

fun main() {
    window.onload = {
        val root = document.getElementById("root") as HTMLElement
        Visage.init(root) {
            GreeterScene(GreeterProps("(loading…)"))
        }
        Visage.render()
    }
}
